"use strict";

PF.Charts = PF.Charts || {};
// https://code.tutsplus.com/ru/tutorials/how-to-draw-a-pie-chart-and-doughnut-chart-using-javascript-and-html5-canvas--cms-27197
PF.Charts.Pie = class Pie extends PF.Widget
{

    static get options()
    {
        return {
            content_id: "piechart-canvas",
            html: PF.Charts.Pie.templates,
            dom: {},
            title: null,
            series: [],
            legends: true,
            doughnutHoleSize: 0, // от 0 до 1
        };
    }

    static get templates()
    {
        return {
            content: `
                <div class="pf-pie-chart-blok" pf="pieChart">
                    <div class="pf-pie-chart-title" pf="pieChartTitle"></div>
                    <canvas class="pf-pie-chart-canvas" pf="pieChartCanvas"></canvas>
                    <div class="pf-pie-chart-legends" pf="pieChartLegend" style="display: flex;"></div>
                </div>
				`,
        };
    }

    init()
    {
        this.state = 'init';
        this.dom.loads(this.html);
        this.dom.element.append(this.dom.content);

        if (this.width && this.height)
        {
            this.bindDom({ pieChartCanvas: "css:width" }, 'width');
            this.bindDom({ pieChartCanvas: "css:height" }, 'height');
            // this.dom.pieChart.node.width = this.width;
            // this.dom.pieChart.node.height = this.height;
        }
        this.dom.pieChartTitle.bindHtml();
        this.dom.pieChartTitle.html = this.title;

        this.dom.pieChartLegend.bindHtml();

        this.canvas = this.dom.pieChartCanvas;
        this.ctx = this.canvas.node.getContext("2d");
    }

    draw()
    {
        let total_value = 0;
        for (let i = 0; i < this.series.length; i++)
        {
            var val = this.series[i];
            total_value += val.data;
        }

        let start_angle = 0;

        let width = this.canvas.width();
        let height = this.canvas.height();

        for (let i = 0; i < this.series.length; i++)
        {
            var val = this.series[i];
            var slice_angle = 2 * Math.PI * val.data / total_value;

            this.drawPieSlice(
                width / 2,
                height / 2,
                Math.min(width / 2, height / 2),
                start_angle,
                start_angle + slice_angle,
                val.color
            );

            start_angle += slice_angle;

            if (this.legends == true)
            {
                this.dom.pieChartLegend.html += "<div><span style='display:inline-block;width:20px;background-color:" + val.color + ";'>&nbsp;</span> " + val.name + "</div>";
            }
        }


        //drawing a white circle over the chart
        //to create the doughnut chart
        if (this.doughnutHoleSize)
        {
            this.drawPieSlice(
                width / 2,
                height / 2,
                this.doughnutHoleSize * Math.min(width / 2, height / 2),
                0,
                2 * Math.PI,
                "#ffffff"
            );
        }

        // показать значения
        start_angle = 0;
        for (let i = 0; i < this.series.length; i++)
        {
            var val = this.series[i];
            var slice_angle = 2 * Math.PI * val.data / total_value;
            var pieRadius = Math.min(width / 2, height / 2);

            var offset = 0;
            if (this.doughnutHoleSize)
            {
                offset = (pieRadius * this.doughnutHoleSize) / 2;
            }
            var labelX = width / 2 + (offset + pieRadius / 2) * Math.cos(start_angle + slice_angle / 2);
            var labelY = height / 2 + (offset + pieRadius / 2) * Math.sin(start_angle + slice_angle / 2);

            var labelText = Math.round(100 * val.data / total_value);
            this.ctx.fillStyle = "white";
            this.ctx.font = "bold 20px Arial";
            this.ctx.fillText(labelText + "%", labelX, labelY);

            start_angle += slice_angle;
        }

    }

    drawPieSlice(centerX, centerY, radius, startAngle, endAngle, color)
    {
        console.log(this.ctx);
        this.ctx.fillStyle = color;
        this.ctx.beginPath();
        this.ctx.moveTo(centerX, centerY);
        this.ctx.arc(centerX, centerY, radius, startAngle, endAngle);
        this.ctx.closePath();
        this.ctx.fill();
    }
}